const DocMenuConfig = [
    {
        pages: [
            {
                heading: "dashboard",
                route: "/dashboard",
                svgIcon: "/media/icons/duotune/art/art002.svg",
                fontIcon: "bi-app-indicator",
            },
            {
                heading: "moduleManagement.userGuide",
                route: "/module/user-guide",
                svgIcon: "/media/icons/duotune/general/gen005.svg",
                fontIcon: "bi-file-earmark-richtext",
            },
            {
                heading: "timetable",
                route: "/timetable",
                svgIcon: "/media/icons/duotune/general/gen014.svg",
                fontIcon: "bi-calendar",
            },
            {
                sectionTitle: "ticketManagement.title",
                route: "/ticket",
                svgIcon: "/media/icons/duotune/communication/com007.svg",
                fontIcon: "bi-chat-square-text",
                sub: [
                    {
                        heading: "ticketManagement.ticket",
                        route: "/ticket",
                    }
                ]
            },
            {
                sectionTitle: "incomeManagement.title",
                route: "/income",
                svgIcon: "/media/icons/duotune/finance/fin010.svg",
                fontIcon: "bi-currency-dollar",
                sub: [
                    {
                        heading: "incomeManagement.collection",
                        route: "/income/collection",
                    },
                    {
                        heading: "incomeManagement.report",
                        route: "/income/report",
                    },
                ]
            }
        ],
    },
    {
        heading: "ecommerceManagement.title",
        route: "/ecommerce",
        pages: [
            {
                sectionTitle: "ecommerceManagement.courseManagement.title",
                route: "/ecommerce/course",
                svgIcon: "/media/icons/duotune/ecommerce/ecm009.svg",
                fontIcon: "bi-grid",
                sub: [
                    {
                        heading: "ecommerceManagement.courseManagement.course",
                        route: "/ecommerce/course",
                    }
                ]
            },
            {
                sectionTitle: "ecommerceManagement.orderManagement.title",
                route: "/ecommerce/order",
                svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
                fontIcon: "bi-cart2",
                sub: [
                    {
                        heading: "ecommerceManagement.orderManagement.order",
                        route: "/ecommerce/order",
                    }
                ]
            }
        ]
    },
    {
        heading: "systemManagement.title",
        route: "/system",
        pages: [
            {
                heading: "systemManagement.bankAccount",
                route: "/system/bank-account",
                svgIcon: "/media/icons/duotune/finance/fin001.svg",
                fontIcon: "bi-bank",
            }
        ]
    }
];

export default DocMenuConfig;
